// extracted by mini-css-extract-plugin
module.exports = {"coe7un":"coe7un"};